import type { CardFormat } from './types'

/**
 * A template provides the HTML for both the feed (1080×1080) and story
 * (1080×1920) formats. New templates are added to the registry in
 * `./registry.ts`; users may also upload their own (stored in localStorage).
 */
export interface TemplateDefinition {
  /** Stable unique id, e.g. "onlyjobs" or "custom-1700000000000". */
  id: string
  /** Human-readable name shown in the selector, e.g. "Default 1". */
  name: string
  /** True for user-uploaded templates kept in localStorage. */
  isCustom?: boolean
  /** HTML for each format. */
  templates: Record<CardFormat, string>
}

/** Expected pixel dimensions of the `.main` root element per format. */
export const EXPECTED_DIMS: Record<CardFormat, { w: number; h: number }> = {
  feed: { w: 1080, h: 1080 },
  story: { w: 1080, h: 1920 },
}

/**
 * Placeholders a template must expose via `data-placeholder="<id>"`.
 * Image placeholders additionally need `data-placeholder-type="image"`.
 */
export const REQUIRED_PLACEHOLDERS = ['title', 'city', 'cta-text', 'logo', 'header-image'] as const

/** Image placeholders that must carry data-placeholder-type="image". */
export const REQUIRED_IMAGE_PLACEHOLDERS = ['logo', 'header-image'] as const

/** Optional placeholders the built-in templates also support. */
export const OPTIONAL_PLACEHOLDERS = ['label', 'subtitle', 'employment-type', 'company'] as const
